import { ErrorString, InvalidOperationException } from "../../shared/index.js";
import { toArray } from "./toArray.js";
export const singleAsync = async (source, predicate) => {
    const results = await toArray(source);
    let hasValue = false;
    let singleValue = null;
    for (const value of results) {
        if (await predicate(value) === true) {
            if (hasValue === true) {
                throw new InvalidOperationException(ErrorString.MoreThanOneMatchingElement);
            }
            else {
                hasValue = true;
                singleValue = value;
            }
        }
    }
    if (hasValue === false) {
        throw new InvalidOperationException(ErrorString.NoMatch);
    }
    return singleValue;
};
